/**
 * Cart drawer top picks: carousel navigation, variant modal, and quick add.
 */
document.addEventListener('DOMContentLoaded', function () {
  var sidebarCart = document.getElementById('sidebar-cart');

  if (!sidebarCart) {
    return;
  }

  var CAROUSEL_SCROLL_MS = 400;

  function getCarousel() {
    return sidebarCart.querySelector('[data-cart-top-picks-carousel]');
  }

  function getSlides(carousel) {
    return Array.prototype.slice.call(carousel.querySelectorAll('.CartTopPicks__slide'));
  }

  function getCurrentSlideIndex(slides, carousel) {
    var scrollLeft = carousel.scrollLeft;
    var index = 0;
    var minDistance = Infinity;

    slides.forEach(function (slide, i) {
      var distance = Math.abs(slide.offsetLeft - scrollLeft);

      if (distance < minDistance) {
        minDistance = distance;
        index = i;
      }
    });

    return index;
  }

  function updateNavButtons() {
    var carousel = getCarousel();

    if (!carousel) {
      return;
    }

    var slides = getSlides(carousel);
    var prevButton = sidebarCart.querySelector('[data-action="cart-top-picks-prev"]');
    var nextButton = sidebarCart.querySelector('[data-action="cart-top-picks-next"]');

    if (!prevButton || !nextButton || slides.length <= 1) {
      return;
    }

    var index = getCurrentSlideIndex(slides, carousel);

    prevButton.disabled = index <= 0;
    nextButton.disabled = index >= slides.length - 1;
  }

  function initCarousel() {
    var carousel = getCarousel();

    if (!carousel) {
      return;
    }

    if (!carousel.dataset.navBound) {
      carousel.dataset.navBound = 'true';
      carousel.addEventListener('scroll', function () {
        if (carousel.dataset.scrolling === 'true') {
          return;
        }

        window.clearTimeout(carousel._navUpdateTimer);
        carousel._navUpdateTimer = window.setTimeout(updateNavButtons, 50);
      }, { passive: true });
    }

    carousel.scrollLeft = 0;
    carousel.dataset.scrolling = 'false';
    updateNavButtons();
  }

  function scrollCarousel(direction) {
    var carousel = getCarousel();

    if (!carousel || carousel.dataset.scrolling === 'true') {
      return;
    }

    var slides = getSlides(carousel);

    if (slides.length <= 1) {
      return;
    }

    var currentIndex = getCurrentSlideIndex(slides, carousel);
    var nextIndex = currentIndex + direction;

    if (nextIndex < 0 || nextIndex >= slides.length) {
      return;
    }

    carousel.dataset.scrolling = 'true';

    carousel.scrollTo({
      left: slides[nextIndex].offsetLeft,
      behavior: 'smooth'
    });

    window.setTimeout(function () {
      carousel.dataset.scrolling = 'false';
      updateNavButtons();
    }, CAROUSEL_SCROLL_MS);
  }

  function formatMoney(cents) {
    if (typeof Currency !== 'undefined' && Currency.formatMoney && window.theme) {
      return Currency.formatMoney(cents, window.theme.moneyFormat);
    }

    return (cents / 100).toFixed(2);
  }

  function getProductData(form) {
    var jsonNode = form.querySelector('[data-product-json]');

    if (!jsonNode) {
      return null;
    }

    try {
      return JSON.parse(jsonNode.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedOptions(form) {
    var options = [];
    var selectedOptions = form.querySelectorAll('[data-cart-top-pick-option]:checked');

    selectedOptions.forEach(function (input) {
      options[parseInt(input.getAttribute('data-option-position'), 10) - 1] = input.value;
    });

    return options;
  }

  function findVariant(product, options) {
    if (!product || !product.variants) {
      return null;
    }

    return product.variants.find(function (variant) {
      return options.every(function (value, index) {
        return variant['option' + (index + 1)] === value;
      });
    });
  }

  function updateModalVariant(form) {
    var product = getProductData(form);
    var options = getSelectedOptions(form);
    var variant = findVariant(product, options);
    var submitButton = form.querySelector('[data-action="cart-top-pick-add"]');
    var priceNode = form.querySelector('[data-cart-top-pick-price]');
    var imageNode = form.querySelector('[data-cart-top-pick-image]');
    var errorNode = form.querySelector('[data-cart-top-pick-error]');

    if (!submitButton || !variant) {
      if (submitButton) {
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.removeAttribute('data-variant-id');
      }

      return;
    }

    submitButton.setAttribute('data-variant-id', variant.id);

    if (variant.available) {
      submitButton.removeAttribute('disabled');
      if (errorNode) {
        errorNode.hidden = true;
        errorNode.textContent = '';
      }
    } else {
      submitButton.setAttribute('disabled', 'disabled');
      if (errorNode) {
        errorNode.hidden = false;
        errorNode.textContent = 'Εξαντλημένο';
      }
    }

    if (priceNode) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceNode.innerHTML = '<span class="Price Price--highlight">' + formatMoney(variant.price) + '</span><span class="Price Price--compareAt">' + formatMoney(variant.compare_at_price) + '</span>';
      } else {
        priceNode.innerHTML = '<span class="Price">' + formatMoney(variant.price) + '</span>';
      }
    }

    if (imageNode && variant.featured_image) {
      imageNode.src = variant.featured_image.src;
    }
  }

  function initModalForms() {
    sidebarCart.querySelectorAll('[data-cart-top-pick-form]').forEach(function (form) {
      updateModalVariant(form);
    });
  }

  function addVariantToCart(variantId) {
    if (!variantId || !window.routes) {
      return Promise.resolve(false);
    }

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start'));

    return fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    }).then(function (response) {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end'));

      if (!response.ok) {
        return response.json().then(function (content) {
          throw new Error(content.description || 'Add to cart failed');
        });
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      var closeButton = document.querySelector('.Modal[aria-hidden="false"] [data-action="close-modal"]');

      if (closeButton) {
        closeButton.click();
      }

      return true;
    });
  }

  sidebarCart.addEventListener('click', function (event) {
    var prevButton = event.target.closest('[data-action="cart-top-picks-prev"]');
    var nextButton = event.target.closest('[data-action="cart-top-picks-next"]');
    var addButton = event.target.closest('[data-action="cart-top-pick-add"]');
    var quickAddButton = event.target.closest('[data-action="cart-top-pick-quick-add"]');

    if (prevButton) {
      event.preventDefault();

      if (!prevButton.disabled) {
        scrollCarousel(-1);
      }

      return;
    }

    if (nextButton) {
      event.preventDefault();

      if (!nextButton.disabled) {
        scrollCarousel(1);
      }

      return;
    }

    if (addButton) {
      event.preventDefault();

      var form = addButton.closest('[data-cart-top-pick-form]');
      var errorNode = form ? form.querySelector('[data-cart-top-pick-error]') : null;

      addVariantToCart(addButton.getAttribute('data-variant-id')).catch(function (error) {
        if (errorNode) {
          errorNode.hidden = false;
          errorNode.textContent = error.message;
        }
      });
      return;
    }

    if (quickAddButton) {
      event.preventDefault();

      addVariantToCart(quickAddButton.getAttribute('data-variant-id')).catch(function (error) {
        window.alert(error.message);
      });
    }
  });

  sidebarCart.addEventListener('change', function (event) {
    if (!event.target.matches('[data-cart-top-pick-option]')) {
      return;
    }

    var form = event.target.closest('[data-cart-top-pick-form]');

    if (form) {
      updateModalVariant(form);
    }
  });

  document.documentElement.addEventListener('cart:refresh', function () {
    window.setTimeout(function () {
      initModalForms();
      initCarousel();
    }, 0);
  });

  initModalForms();
  initCarousel();
});

document.addEventListener('click', function (event) {
  var openTrigger = event.target.closest('[data-action="open-mwm-sg"]');
  var closeTrigger = event.target.closest('[data-action="close-mwm-sg"]');
  var modal = document.getElementById('mwm_sg-imageModal');

  if (!modal) {
    return;
  }

  if (openTrigger) {
    event.preventDefault();
    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    return;
  }

  if (closeTrigger || (modal.classList.contains('is-visible') && event.target === modal)) {
    event.preventDefault();
    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
});

(function () {
  function getGalleryImages(media) {
    return Array.prototype.slice.call(media.querySelectorAll('.ProductItem__ImageWrapper--gallery .ProductItem__Image'));
  }

  function unveilImage(image) {
    if (!image) {
      return;
    }

    if (!image.classList.contains('Image--lazyLoad')) {
      image.classList.add('Image--lazyLoad');
    }

    if (window.lazySizes && typeof window.lazySizes.loader !== 'undefined' && window.lazySizes.loader.unveil) {
      window.lazySizes.loader.unveil(image);
    }
  }

  function showGalleryImage(media, index) {
    var images = getGalleryImages(media);

    if (images.length < 2) {
      return;
    }

    var nextIndex = Math.max(0, Math.min(index, images.length - 1));

    images.forEach(function (image, imageIndex) {
      var isSelected = imageIndex === nextIndex;
      image.classList.toggle('is-selected', isSelected);
      image.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
    });

    unveilImage(images[nextIndex]);
  }

  function currentGalleryIndex(images) {
    var current = images.findIndex(function (image) {
      return image.classList.contains('is-selected');
    });

    return current < 0 ? 0 : current;
  }

  document.addEventListener('click', function (event) {
    var prevButton = event.target.closest('[data-product-gallery-prev]');
    var nextButton = event.target.closest('[data-product-gallery-next]');

    if (!prevButton && !nextButton) {
      return;
    }

    var media = (prevButton || nextButton).closest('.ProductItem__Media');

    if (!media) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var images = getGalleryImages(media);
    var current = currentGalleryIndex(images);
    var delta = prevButton ? -1 : 1;

    showGalleryImage(media, current + delta);
  }, true);
})();

(function () {
  var CARRY_KEY = 'gang_collection_row_carry';
  var COLUMN_MULTIPLE = 4;

  function getGrid() {
    return document.querySelector('.template-collection .ProductList--grid');
  }

  function normalizePath(url) {
    if (!url) {
      return '';
    }

    try {
      var anchor = document.createElement('a');
      anchor.href = url;
      return (anchor.pathname || '') + (anchor.search || '');
    } catch (error) {
      return url;
    }
  }

  function currentPath() {
    return window.location.pathname + window.location.search;
  }

  function getCells(grid) {
    return Array.prototype.filter.call(grid.children, function (child) {
      return child.classList && child.classList.contains('Grid__Cell');
    });
  }

  function hasNextPage(grid) {
    if (grid.getAttribute('data-has-next-page') === 'true') {
      return true;
    }

    return !!document.querySelector('.template-collection a[rel="next"]');
  }

  function nextPagePath(grid) {
    var fromData = grid.getAttribute('data-next-page-url');

    if (fromData) {
      return normalizePath(fromData);
    }

    var nextLink = document.querySelector('.template-collection a[rel="next"]');
    return nextLink ? normalizePath(nextLink.getAttribute('href')) : '';
  }

  function applyCarry(grid) {
    var raw;

    try {
      raw = window.sessionStorage.getItem(CARRY_KEY);
    } catch (error) {
      return;
    }

    if (!raw) {
      return;
    }

    var data;

    try {
      data = JSON.parse(raw);
    } catch (error) {
      window.sessionStorage.removeItem(CARRY_KEY);
      return;
    }

    if (!data || !data.nextPath) {
      window.sessionStorage.removeItem(CARRY_KEY);
      return;
    }

    var here = normalizePath(currentPath());

    if (here === normalizePath(data.nextPath)) {
      var markup = Array.isArray(data.html) ? data.html : [];
      var fragment = document.createDocumentFragment();

      markup.forEach(function (html) {
        var wrap = document.createElement('div');
        wrap.innerHTML = html;
        var cell = wrap.firstElementChild;

        if (cell) {
          fragment.appendChild(cell);
        }
      });

      if (fragment.firstChild) {
        grid.insertBefore(fragment, grid.firstChild);
      }

      window.sessionStorage.removeItem(CARRY_KEY);
      return;
    }

    if (here === normalizePath(data.fromPath)) {
      return;
    }

    window.sessionStorage.removeItem(CARRY_KEY);
  }

  function trimIncompleteRow(grid) {
    if (!hasNextPage(grid)) {
      return;
    }

    var list = getCells(grid);
    var leftover = list.length % COLUMN_MULTIPLE;

    if (!leftover) {
      return;
    }

    var nextPath = nextPagePath(grid);

    if (!nextPath) {
      return;
    }

    var moving = list.slice(-leftover);
    var payload = {
      fromPath: currentPath(),
      nextPath: nextPath,
      html: moving.map(function (cell) {
        return cell.outerHTML;
      })
    };

    try {
      window.sessionStorage.setItem(CARRY_KEY, JSON.stringify(payload));
    } catch (error) {
      return;
    }

    moving.forEach(function (cell) {
      cell.remove();
    });
  }

  function completeCollectionRows() {
    var grid = getGrid();

    if (!grid) {
      return;
    }

    if (grid.querySelector('[data-behavior="variable-products"]')) {
      grid.removeAttribute('data-rows-completed');
      return;
    }

    applyCarry(grid);

    if (grid.getAttribute('data-rows-completed') === 'true') {
      return;
    }

    trimIncompleteRow(grid);
    grid.setAttribute('data-rows-completed', 'true');
  }

  function waitForVariableProducts(done) {
    var tries = 0;

    (function tick() {
      var pending = document.querySelector('.template-collection .ProductList--grid [data-behavior="variable-products"]');

      if (!pending || tries > 40) {
        done();
        return;
      }

      tries += 1;
      window.setTimeout(tick, 50);
    })();
  }

  function scheduleComplete() {
    waitForVariableProducts(completeCollectionRows);
  }

  document.addEventListener('DOMContentLoaded', scheduleComplete);

  var productsRoot = document.querySelector('.CollectionInner__Products');

  if (productsRoot) {
    var debounce;

    new MutationObserver(function () {
      window.clearTimeout(debounce);
      debounce = window.setTimeout(scheduleComplete, 150);
    }).observe(productsRoot, { childList: true, subtree: true });
  }
})();

(function () {
  if (!document.body || !document.body.classList.contains('template-product')) {
    return;
  }

  function openKlarnaLearnMore() {
    var placements = document.querySelectorAll('.ProductTrustWrap klarna-placement, klarna-placement');

    for (var i = 0; i < placements.length; i += 1) {
      var root = placements[i].shadowRoot;
      if (!root) continue;

      var trigger = root.querySelector('button.link, .link, a, button');
      if (trigger) {
        trigger.click();
        return;
      }
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-gang-klarna-more]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    openKlarnaLearnMore();
  });
})();
